import { cva } from '@/styled-system/css';

export const duoColorIconRecipe = cva({
  base: {
    'alignItems': 'center',
    'blockSize': 'icon.xl',
    'borderRadius': 'obj.default',
    'display': 'flex',
    'flex': '0 0 auto',
    'inlineSize': 'icon.xl',
    'justifyContent': 'center',
    '& [data-c11n-component="Icon"]': {
      blockSize: 'icon.md',
      inlineSize: 'icon.md',
    },
  },
  compoundVariants: [
    // trust variants
    {
      tone: 'trust',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.express.trust.impact',
        color: 'icon.onImpact.express.trust.hero',
      },
    },
    {
      tone: 'trust',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.express.trust.impact',
        color: 'icon.onImpact.express.trust.hero',
      },
    },
    {
      tone: 'trust',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.express.trust.hero',
        color: 'icon.onHero.express.trust.hero',
      },
    },

    // insight variants
    {
      tone: 'insight',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.express.insight.impact',
        color: 'icon.onImpact.express.insight.hero',
      },
    },
    {
      tone: 'insight',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.express.insight.impact',
        color: 'icon.onHero.express.insight.hero',
      },
    },
    {
      tone: 'insight',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.express.insight.hero',
        color: 'icon.onHero.express.insight.hero',
      },
    },

    // inspire variants
    {
      tone: 'inspire',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.express.inspire.impact',
        color: 'icon.onImpact.express.inspire.hero',
      },
    },
    {
      tone: 'inspire',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.express.inspire.impact',
        color: 'icon.onHero.express.inspire.hero',
      },
    },
    {
      tone: 'inspire',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.express.inspire.hero',
        color: 'icon.onHero.express.inspire.hero',
      },
    },

    // empower variants
    {
      tone: 'empower',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.express.empower.impact',
        color: 'icon.onImpact.express.empower.hero',
      },
    },
    {
      tone: 'empower',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.express.empower.impact',
        color: 'icon.onImpact.express.empower.hero',
      },
    },
    {
      tone: 'empower',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.express.empower.hero',
        color: 'icon.onHero.express.empower.hero',
      },
    },

    // info variants
    {
      tone: 'info',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.feedback.info.impact',
        color: 'icon.onImpact.feedback.info.strong',
      },
    },
    {
      tone: 'info',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.feedback.info.impact',
        color: 'icon.onImpact.feedback.info.strong',
      },
    },
    {
      tone: 'info',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.feedback.info.hero',
        color: 'icon.onImpact.feedback.info.strong',
      },
    },

    // success variants
    {
      tone: 'success',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.feedback.success.impact',
        color: 'icon.onImpact.feedback.success.strong',
      },
    },
    {
      tone: 'success',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.feedback.success.impact',
        color: 'icon.onImpact.feedback.success.strong',
      },
    },
    {
      tone: 'success',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.feedback.success.hero',
        color: 'icon.onImpact.feedback.success.strong',
      },
    },

    // critical variants
    {
      tone: 'critical',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.feedback.critical.hero',
        color: 'icon.onImpact.feedback.critical.strong',
      },
    },
    {
      tone: 'critical',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.feedback.critical.impact',
        color: 'icon.onImpact.feedback.critical.strong',
      },
    },
    {
      tone: 'critical',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.feedback.critical.hero',
        color: 'icon.onImpact.feedback.critical.strong',
      },
    },

    // warning variants
    {
      tone: 'warning',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.feedback.warning.hero',
        color: 'icon.onImpact.feedback.warning.strong',
      },
    },
    {
      tone: 'warning',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.feedback.warning.impact',
        color: 'icon.onImpact.feedback.warning.strong',
      },
    },
    {
      tone: 'warning',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.feedback.warning.hero',
        color: 'icon.onImpact.feedback.warning.strong',
      },
    },

    // notify variants
    {
      tone: 'notify',
      onBackground: 'default',
      css: {
        backgroundColor: 'bg.feedback.notify.hero',
        color: 'icon.onImpact.feedback.notify.strong',
      },
    },
    {
      tone: 'notify',
      onBackground: 'hero',
      css: {
        backgroundColor: 'bg.feedback.notify.impact',
        color: 'icon.onImpact.feedback.notify.strong',
      },
    },
    {
      tone: 'notify',
      onBackground: 'impact',
      css: {
        backgroundColor: 'bg.feedback.notify.hero',
        color: 'icon.onImpact.feedback.notify.strong',
      },
    },
  ],
});
